(async () => {

  if (!customElements.get('product-size-table')) {

    const { Fancybox } = await import("@fancyapps/ui");

    class ProductSizeTable extends HTMLElement {
      constructor() {
        super();

        this.fancybox();
      }

      /*
      * Create fancybox
      */
      fancybox() {

        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        this.querySelector("[data-fancybox-sizetable]").addEventListener('click', function(event){
          event.preventDefault();
          const url = this.getAttribute("href") + '?view=ajax';
          Fancybox.show(
            [
              {
                src: url,
                type: "ajax",
              }
            ],
            {
              mainClass: "product__size-table-popup",
              animated: false
            }
          );
        })
      }
    }

    window.ProductSizeTable = ProductSizeTable;

    customElements.define('product-size-table', ProductSizeTable);

  }

})();
